/**
 * @author wql
 * @description 新增/编辑
 * @Date  2020/9/28
 */
import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import LiveForm from './subjectForm'
import moment from "moment";
import { formatAuth } from '@/utils/commonUtils'

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class SubjectDetail extends WizContainer {
  componentName = 'SubjectDetail';

  constructor(props) {
    super(props);
    const { history } = this.props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增';
    if (history.location && history.location.pathname === '/credit/subjectList/subjectDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('subjectDetailUpd', initialValue)
      } else {
        initialValue = Session.get('subjectDetailUpd') || {};
      }
      cardTitle = '编辑'
      if (initialValue.startDate) {
        initialValue.startDate = moment(initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (initialValue.endDate) {
        initialValue.endDate = moment(initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
    }
    this.state = {
      cardTitle: cardTitle,
      formKey: 'liveForm',
      formInitialValue:{}
    }
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'interactLive/getInfo',
        payload: {
          key: "getLiveInfo",
          apiParams: {
            id: this.initialValue.id
          }
        }
      });
    }
  }


  propsAndStateOnChange = {
    saveLive: this._saveLiveOver.bind(this),
    liveInfo: this._getliveInfoOver.bind(this)
  }


  _saveLiveOver(nextProps, nextState) {
    if (nextProps.saveLive.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/credit/subjectList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveLive.msg);
    }
    return true;
  }

  _getliveInfoOver(nextProps, nextState) {
    if (nextProps.liveInfo.code == 1) {
      this.initialValue = nextProps.liveInfo.data;
      //数据拼接
      // if(this.initialValue.hostId && this.initialValue.hostName){
      //   this.initialValue.personInfo = [{key:'1',personId:this.initialValue.hostId, fullName:this.initialValue.hostName ,id:this.initialValue.hostId,fullName:this.initialValue.hostName}]
      // }
      if(this.initialValue.liveCategoryId && this.initialValue.categoryName){
        this.initialValue.categoryInfo = [{key:this.initialValue.liveCategoryId,title:this.initialValue.categoryName}]
      }
      if (this.initialValue.startDate) {
        this.initialValue.startDate = moment(this.initialValue.startDate, 'YYYY-MM-DD HH:mm:ss')
      }
      if (this.initialValue.endDate) {
        this.initialValue.endDate = moment(this.initialValue.endDate, 'YYYY-MM-DD HH:mm:ss')
      }
      nextState.formInitialValue = Object.assign({},this.initialValue)
      nextState.formKey = 'liveForm' + new Date().getTime()
    }
    return true;
  }


  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const { history } = this.props;
    let apiPath = "subject/add";
    if (this.initialValue.id) {
      apiPath = "subject/update";
    }

    // let authCmd = {}
    // if (values['authCmd']) {
    //   let authInfo = values['authCmd']
    //   authCmd.isAll = authInfo.isAll
    //   authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
    //   authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
    //   authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
    //   authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))
    // }
    // if (authCmd['orgIds'].length == 0 && authCmd['positionIds'].length == 0 && authCmd['positionCategoryIds'].length == 0 && authCmd['personIds'].length == 0){
    //   wizNotice.error('提交失败：' + '请填写适用范围');
    //   return false;
    // }
    // values['authCmd'] = authCmd;

    values.authCmd = formatAuth(values.authCmd)

    this.doAction({
      path: apiPath,
      payload: {
        key: "saveLive",
        apiParams: {
          ...values,
          id: this.initialValue.id
        }
      }
    });
  }


  _render() {
    const { interactLiveLoading } = this.props;
    let { cardTitle, formInitialValue } = this.state;



    return <WizCard>
      <WizSpin tip={'加载中'} spinning={interactLiveLoading}>

        <LiveForm className={'form-inline'} key={this.state.formKey} initialValue={this.initialValue}
          onSubmit={this._save.bind(this)} />

      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLive ,subject} = state;
  const saveLive = modelUtils.getModelEntity(subject, "saveLive");
  const liveInfo = modelUtils.getModelEntity(subject, "getLiveInfo");
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    saveLive: saveLive,
    liveInfo,
    ...load
  }
};

export default connect(mapStateToProps)(SubjectDetail);
